import Skeleton from "@material-ui/lab/Skeleton";

export default function ProgressDialogSkeleton() {
    return (
        <div>
            <div className="ProgressDialog-goal-title-container">
                <Skeleton variant="text" width={260} height={32} />
                <Skeleton variant="rect" width={120} height={24} />
            </div>
            <Skeleton variant="text" height={20} width='100%'/>
            <Skeleton variant="text" height={20} width='100%'/>
            <div className="ProgressDialog-deadline">
                <Skeleton variant="text" width={100} height={24} />
                <Skeleton variant="text" width={100} height={24} />
            </div>
            <div className="ProgressDialog-record-container">
                <Skeleton variant="text" width={40} height={24} />
                <Skeleton variant="rect" width='100%' height={80} />
                <div className="ProgressDialog-actions-container">
                    <Skeleton variant="rect" width={86} height={26} />
                    <Skeleton variant="rect" width={200} height={26} />
                </div>
            </div>
            <div className="ProgressDialog-bottom-container">
                <Skeleton variant="text" width='50%' height={16}/>
                <div className="ProgressDialog-actions">
                    <Skeleton variant="rect" width={100} height={28} />
                    <Skeleton variant="rect" width={100} height={28} />
                </div>
            </div>
        </div>
    )
}